import React from "react";
import { Link } from "react-router-dom";
import Slider from "react-slick";

const services = [
  {
    title: "Web Development",
    desc: "Custom, responsive, and scalable websites tailored to your business goals.",
    img: "/carousel/webdev.png",
    alt: "Best Web Development Services",
    href: "/aI-based-web-development-services",
  },
  {
    title: "App Development",
    desc: "Smart mobile and web apps designed for performance, usability, and growth.",
    img: "/carousel/appdev.png",
    alt: "App Development images",
    href: "/aI-based-app-development-services",
  },
  {
    title: "Staffing Solutions",
    desc: "AI-driven recruitment for Indian and U.S. markets to meet your talent needs.",
    img: "/carousel/staffing.png",
    alt: "Staffing Solutions in India",
    href: "/aI-integrated-staffing-solutions",
  },
  {
    title: "SMS & WhatsApp API Solutions! ",
    desc: "Fast, reliable promotional and transactional messaging with intelligent delivery. Automated, AI-enabled customer engagement through WhatsApp integration. ",
    img: "/carousel/smsmarketing.png",
    alt: "Lead Generation Services",
    href: "/sms-whatsapp-api-solutions",
  },
  {
    title: "Digital Marketing",
    desc: "AI-powered strategies to boost visibility, engagement, and ROI across digital channels.",
    img: "/carousel/digitalmarketing.png",
    alt: "Best Digital Marketing Services",
    href: "/services",
  },
];

const OurServices = () => {
  const settings = {
    dots: false,
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    speed: 2000,
    autoplaySpeed: 750,
    cssEase: "linear",
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  return (
    <section className="px-6 max-w-7xl mx-auto">
      <div className="text-center mb-10">
        <h2 className="text-5xl text-black-700 font-bold">
          Our Smart Business Solutions
        </h2>
        <p className="mt-2 text-black-700 max-w-7xl text-xl mx-auto mb-12">
          We provide a comprehensive suite of AI-powered digital solutions
          designed to fuel business growth, streamline operations, and enhance
          customer engagement across industries.
        </p>
        <Slider {...settings}>
          {services.map((service) => (
            <div key={service.title} className="px-4">
              <Link to={service.href}>
                <div className="overflow-hidden  transition-shadow duration-300 ">
                  <img
                    src={service.img}
                    alt={service.title}
                    className="w-full h-48 object-cover"
                  />
                  <div className="text-left py-1">
                    <h3 className="text-2xl font-bold mb-2">{service.title}</h3>
                    <p className="text-sm font-bold text-[#276191]">
                      {service.desc}
                    </p>
                  </div>
                </div>
              </Link>
            </div>
          ))}
        </Slider>
      </div>
    </section>
  );
};

export default OurServices;
